import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserSettings, UserSettingsUpdate } from '@acp/shared';
import { updateSettings } from '../service';

export function useSettingsUpdate({
    onSuccess,
}: {
    onSuccess: (updatedSettings: UserSettings) => void;
} = {
    onSuccess: () => {},
}) {
    const toast = useToast();
    const queryClient = useQueryClient();

    const updateMutation = useMutation({
        mutationFn: async (settings: UserSettingsUpdate) => updateSettings(settings),
        onSuccess: (updatedSettings) => {
            toast({
                title: 'Settings updated',
                description: 'Settings have been successfully updated.',
                status: 'success',
                isClosable: true,
            });

            void queryClient.invalidateQueries({
                queryKey: ['user-settings'],
            });

            onSuccess(updatedSettings);
        },
        onError: (error) => {
            toast({
                title: 'Error updating settings',
                description: error.message,
                status: 'error',
                isClosable: true,
            });
        },
    });

    return {
        update: updateMutation.mutate,
        isPending: updateMutation.isPending,
        reset: updateMutation.reset,
    };
}
